import axios, { Canceler } from 'axios';
import { Supplier } from '../interfaces/Supplier';
import { getUrlSupplierApi } from '../utils/util';
import ApiHandler from './ApiHandler';

const cancelToken = axios.CancelToken;
let cancel: Canceler;

export const baseURL = String(getUrlSupplierApi(window));

export default class SupplierApi {
    
    static async getStartsWith(text: any) {
        return await ApiHandler(baseURL).get(`supplier/startsWith?beginsWith=${text.code}`);
    }

    static async search(text: string, plantId: string, serviceType?: string, systemID?: number, indCDLC?: boolean) {
        if (cancel !== undefined){
            cancel('cancelled-by-request');
        }

        var parameters = `text=${text.trim()}&plantId=${plantId}&systemID=${systemID}&rowsPerPage=45`

        if (serviceType && serviceType !== "")
            parameters = parameters + `&serviceType=${serviceType}`
        
        if (indCDLC)
            parameters = parameters + `&CDLC=${indCDLC}`

        var response = await ApiHandler(baseURL).get(`Supplier/searchSupplierIsJit?${parameters}`, {
            cancelToken: new cancelToken(c => {
                cancel = c;
            })
        });

        response.data = this.distinctSuppliers(response.data, 15);

        return response.data;
    }

    static async searchSuppliers(supplierIds: any[], plantId: string, companyId: string = '', pageSize: any = 20) {
        var parameters = `plantId=${plantId}&companyId=${companyId}&rowsPerPage=${pageSize}`;
        //Correção pra funcionar para Fiape
        const validSupplierIds = (supplierIds ?? []).filter(
            (x: any) => x !== null && x !== undefined && String(x).trim() !== ''
        );

        validSupplierIds.forEach((x: string) => {
            parameters += `&supplierIDs=${x}`;
        });

        var response = await ApiHandler(baseURL).get(`Supplier/Search?${parameters}`, {timeout: 10000});

        response.data = this.distinctSuppliers(response.data, 20);

        return response.data;
    }

    static async get(code: number, companyId: string) {
        var response = await ApiHandler(baseURL).get(`Supplier/${code.toString().trim()}?companyId=${companyId}`);
        return response.data;
    }

    // A pesquisa por plantId eh realizada com ate 45 itens, pois buscando Fornecedores da planta, pode trazer 3 do mesmo fornecedor para plantas diferentes.
    // Entao, agora iremos filtrar para trazer apenas 15 itens, e que nao sejam "repetidos".
    static distinctSuppliers(responseData: any, pageSize: any = 15)
    {
        const filteredList: Supplier[] = [];
        responseData?.items?.forEach((item: Supplier) => {
            if (filteredList.length < pageSize && !filteredList.some((x: Supplier) => x.supplierID === item.supplierID && x.supplierSAP === item.supplierSAP))
                filteredList.push(item);
        });

        responseData.items = filteredList;
        responseData.pageSize = pageSize;
        if (responseData.indexFrom === 0)
            responseData.totalCount = filteredList.length;

        return responseData;
    }
}
